import React from 'react';
// Import the React Bootstrap components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

export default function Hero() {
  return (
    <section id="home" className="py-5 text-center" style={{ backgroundColor: '#fff' }}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            
            {/* Main Heading */}
            <h1 className="display-5 fw-bold text-dark mb-4" style={{ letterSpacing: '-0.5px' }}>
              Innovative Solutions for the <br className="d-none d-sm-inline" />
             Modern World: 
             <br/>
             <span style={{ color: '#0ab39c' }}> With Tushar Suryawanshi Management Pvt. Ltd</span>
            </h1>

            {/* Subtitle text */}
            <p className="lead text-secondary mb-5 px-md-5 fs-5" style={{ lineHeight: '1.8' }}>
              At TSM Pvt. Ltd, we build future-ready technology that powers modern businesses to scale fast and perform smarter.
            </p>

            {/* Action Buttons */}
            <div className="d-flex justify-content-center align-items-center gap-3">
              
              {/* Dark Blue Button */}
              {/* <Button 
                style={{ backgroundColor: '#405189', borderColor: '#405189' }} 
                className="px-4 py-2.5 fw-medium shadow-sm d-flex align-items-center"
                href="#contact"
              >
                Get Started <span className="ms-2">→</span>
              </Button> */}

            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
}
